import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    Typography,
    MenuItem,
    OutlinedInput,
    Paper,
    TextField,
    Checkbox,
    Select,
    FormHelperText
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
}

const CycleCreate = (props) => {
    const { t, i18n } = useTranslation();
    let { serial, cycleID } = useParams()
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
        dateTimePicker: {
            display: "flex !important",
            flexDirection: "column !important",
            // justifyContent: "space-between !important",
            position: "relative",
            // marginBottom: "14px !important",
            '& div > .MuiOutlinedInput-root': {
                height: "40px !important",
                marginTop: "16px"
            },
            '& div > .MuiOutlinedInput-root > input': {
                paddingTop: 0,
                paddingBottom: 0,
            },
            '& div > .MuiOutlinedInput-root > div > button': {
                width: "100%",
                position: "absolute",
                left: "0",
                justifyContent: "flex-end",
                height: "100%",
                borderRadius: "0",
                "&:hover": {
                    backgroundColor: "transparent",
                },
                "& > span": {
                    display: "none"
                }
            },
            "& div > p": {
                // color: " #d32f2f !important",
                // fontSize: "14px",
                // lineHeight: "15.4px",
                // marginLeft: 0,
                // position: "absolute",
                // bottom: "-22px",
            },
            "& > p": {
                // color: " #d32f2f !important",
                // fontSize: "14px",
                // lineHeight: "15.4px",
                // marginLeft: 0,
                // position: "absolute",
                // bottom: "-22px",
            }
        },
        dateTimePickerDis: {
            display: "flex !important",
            flexDirection: "column !important",
            // justifyContent: "space-between !important",
            position: "relative",
            // marginBottom: "14px !important",
            "&  > div > div ": {
                backgroundColor: "#FAFAFA !important",
            },
            '& div > .MuiOutlinedInput-root': {
                marginTop: "16px",
                height: "40px !important",
            },
            '& div > .MuiOutlinedInput-root > input': {
                paddingTop: 0,
                paddingBottom: 0,
            },
            '& div > .MuiOutlinedInput-root > div > button': {
                width: "100%",
                position: "absolute",
                left: "0",
                justifyContent: "flex-end",
                height: "100%",
                borderRadius: "0",
                "&:hover": {
                    backgroundColor: "transparent",
                },
                "& > span": {
                    display: "none"
                }
            },
            '& div > .MuiOutlinedInput-notchedOutline': {
                border: "none",
                // borderColor: "#d32f2f !important"
            },
            "& div > p": {
                color: " #d32f2f !important",
                // fontSize: "14px",
                // lineHeight: "15.4px",
                // marginLeft: 0,
                position: "absolute",
                bottom: "-22px",
            },
            "& > p": {
                color: " #d32f2f !important",
                // fontSize: "14px",
                // lineHeight: "15.4px",
                // marginLeft: 0,
                position: "absolute",
                bottom: "-22px",

            },
            "fieldset": {
                borderColor: "#d32f2f !important",
            }
        },
        // errorDate: {
        //     "& div > .MuiOutlinedInput-input": {
        //         borderColor: "#d32f2f !important"
        //     }
        //   }
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [checkCode, setCheckCode] = React.useState(false);
    const [status, setStatus] = React.useState(true);
    const [edit, setEdit] = React.useState(true);
    const [save, setSave] = React.useState(false);
    // const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [adjust, setAdjust] = React.useState(true);
    const handleStatus = () => {
        setStatus(!status)
    }
    const [defaults, setDefault] = React.useState(false);
    const onCheckDefault = () => {
        setDefault(!defaults)
    }
    const [minDate, setMinDate] = React.useState(Util.formatDate(new Date()))
    const [maxDate, setMaxDate] = React.useState(Util.formatDate(new Date()))
    const defaultCycleType = [
        {
            value: "annual",
            text: i18n === "th-TH" ? "รายปี" : "Annual Evaluation"
        },
        {
            value: "360",
            text: "360° Evaluation"
        },
    ]
    const [typeDropdown, setTypeDropdown] = React.useState(defaultCycleType)
    const [have360, setHave360] = React.useState(true)

    const validationSchema = yup.object({
        // code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        startDate: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')).nullable(),
        endDate: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')).nullable(),
        nameTH: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        type: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            nameEN: '',
            nameTH: '',
            startDate: null,
            endDate: null,
            type: defaultCycleType?.[0]?.value ?? "annual",
            makeDefault: false
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log("onSubmit values: ", values)
            submit(values)
        },
    })

    const handleSubmit = () => {
        formik.setFieldTouched("type")
        console.log("type", formik.values.type)
        formik.submitForm()
        console.log("form values: ", formik.values);
    }

    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    }

    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    }

    const [discardDialog, setDiscardDialog] = React.useState(false)
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    }

    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        clickLink('/admin/cycle')
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false)
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    }

    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/cycle', { replace: false });
    }

    const submit = () => {
        if (serial !== undefined && serial !== null) {
            adminService.editCycle(serial, {
                code: formik.values.code,
                name_th: formik.values.nameTH,
                name_en: formik.values.nameEN,
                status: "active",
                start_date: Util.formatDate(formik.values.startDate),
                end_date: Util.formatDate(formik.values.endDate),
                is_default: formik.values.makeDefault,
                type: formik.values.type
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.cycleEditFail`))
                handleOpenFailedMessageDialog(true)
            })
        } else {
            adminService.createCycle({
                code: formik.values.code,
                name_th: formik.values.nameTH,
                name_en: formik.values.nameEN,
                status: "active",
                start_date: formik.values.startDate,
                end_date: formik.values.endDate,
                is_default: formik.values.makeDefault,
                type: formik.values.type
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.cycleCreatedFail`))
                handleOpenFailedMessageDialog(true)
            })
        }

    }
    const selectDate = (field, data) => {
        formik.setFieldValue(field, Util.formatDate(data))
    };
    // const onCheckStartDate = (val) => {
    //     setStartDate(Util.formatDate(val))
    // }
    // const onCheckEndDate = (val) => {
    //     setEndDate(Util.formatDate(val))
    // }
    const handleCheckMakeDefault = () => {
        formik.setFieldValue("makeDefault", !formik.values.makeDefault)
    }

    const handleChangeType = (type) => {
        formik.setFieldTouched("type")
        formik.setFieldValue("type", type)
    }

    // useEffect(() => {
    //     const date = new Date(startDate);
    //     date.setDate(date.getDate());
    //     setMinDate(date)
    // }, [startDate])
    useEffect(() => {
        adminService.getCycleConfig().then(
            (resp) => {
                if (resp?.data?.config) {
                    console.log(resp.data.config)
                    setHave360(resp.data.config?.have_360 ?? false)
                }
            },
        )
        if (serial !== undefined && serial !== null) {
            adminService.getEditCycle(serial).then((rs) => {
                formik.setFieldValue("code", rs?.data?.cycle?.code)
                formik.setFieldValue("nameEN", rs?.data?.cycle?.options?.name_en !== undefined && rs?.data?.cycle?.options?.name_en !== null ? rs?.data?.cycle?.options?.name_en : rs?.data?.cycle?.name)
                formik.setFieldValue("nameTH", rs?.data?.cycle?.options?.name_th !== undefined ? rs?.data?.cycle?.options?.name_th : "")
                formik.setFieldValue("startDate", (rs?.data?.cycle?.start_date).replace(/-/g, "/").replace(/T/g, " "))
                formik.setFieldValue("endDate", (rs?.data?.cycle?.end_date).replace(/-/g, "/").replace(/T/g, " "))
                formik.setFieldValue("makeDefault", rs?.data?.cycle?.is_current)
                formik.setFieldValue("type", rs?.data?.cycle?.type ?? "")
                setStatus(rs?.data?.cycle?.status === "active" ? true : false)
                // setAdjust(rs?.data?.cycle?.options?.allow_adjust === true ? true : false)
                setEdit(rs?.data?.cycle?.code)
                setSave(false)
            })
        }
    }, [])

    useEffect(() => {
        if (save === false) {
            setSave(true)
        }
    }, [formik.values, status, defaults])

    useEffect(() => {
        const date = new Date(formik.values.startDate);
        date.setDate(date.getDate() + 1);
        setMinDate(date)
    }, [formik.values.startDate])

    useEffect(() => {
        if (!have360) {
            let result = [...typeDropdown].filter(item => item.value !== "360")
            setTypeDropdown(result)
        }
    }, [have360])
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container item pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/cycle')}>{t('admin.label.cycle')}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editCycle') : t('admin.label.createCycle')}</span></Typography>
                    </Grid>
                    <Grid container item xs={12}>
                        <Typography variant="h1" color="#404349" fontSize={36} lineHeight="53.82px" fontWeight="600">
                            {serial !== undefined ? t('admin.label.editCycle') : t('admin.label.createCycle')}
                        </Typography>
                    </Grid>
                    <Grid container item xs>
                        <Paper elevation={6} sx={{ borderRadius: '20px', width: '100%', p: "25px" }}>
                            {serial !== undefined ?
                                <Grid container display="flex" mb={2} columnSpacing={4}>
                                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                        <Typography fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                        <TextField
                                            error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                            fullWidth
                                            helperText={formik.touched.code && formik.errors.code}
                                            margin="normal"
                                            name="code"
                                            disabled={serial !== undefined ? true : false}
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            type="text"
                                            value={formik.values.code}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            placeholder={t('admin.inputForm.placeholder.code')}
                                            classes={{ root: serial !== undefined ? classes.disabled : classes.input }}
                                        />
                                        {/* {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')} </FormHelperText>) : <></>} */}
                                    </Grid>
                                </Grid>
                                : null
                            }
                            <Grid container display="flex" mb={2} columnSpacing={4}>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": edit === false ? "#FAFAFA" : "", "-webkit-text-fill-color": edit === false ? "#000 !important" : "" }, "fieldset": { "border-color": edit === false ? "#FFFFFF !important" : "" } }}>
                                    <Typography fontWeight="500" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <TextField
                                        error={Boolean(formik.touched.nameEN && formik.errors.nameEN)}
                                        fullWidth
                                        helperText={formik.touched.nameEN && formik.errors.nameEN}
                                        margin="normal"
                                        name="nameEN"
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        type="text"
                                        value={formik.values.nameEN}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.nameEN')}
                                        classes={{ root: classes.input }}
                                    />
                                </Grid>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": edit === false ? "#FAFAFA" : "", "-webkit-text-fill-color": edit === false ? "#000 !important" : "" }, "fieldset": { "border-color": edit === false ? "#FFFFFF !important" : "" } }}>
                                    <Typography fontWeight="500" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <TextField
                                        error={Boolean(formik.touched.nameTH && formik.errors.nameTH)}
                                        fullWidth
                                        helperText={formik.touched.nameTH && formik.errors.nameTH}
                                        margin="normal"
                                        name="nameTH"
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        type="text"
                                        value={formik.values.nameTH}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.nameTH')}
                                        classes={{ root: classes.input }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container display="flex" mb={2} columnSpacing={4}>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }} classes={{ root: classes.dateTimePicker }}>
                                    <Typography fontWeight="500" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.label.startDate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                                        <DesktopDatePicker
                                            slots={{
                                                OpenPickerIcon: serial !== undefined ? adjust === true ? Calendar : null : Calendar
                                            }}
                                            format="dd/MM/yyyy"
                                            value={formik.values.startDate}
                                            onChange={(newValue) => {
                                                // onCheckStartDate(newValue)
                                                selectDate("startDate", newValue);
                                            }}
                                            // minDate={new Date()}
                                            // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                            inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                            renderInput={(params) => <TextField  {...params}
                                                fullWidth
                                                sx={{
                                                    ".MuiOutlinedInput-root": { color: "#404349", },
                                                    ".MuiOutlinedInput-notchedOutline": formik.touched.startDate && formik.errors.startDate ? { borderColor: "#d32f2f !important" } : "",
                                                }}
                                            // classes={{ root: serial !== undefined ? adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                            }
                                        />
                                    </LocalizationProvider>
                                    {formik.touched.startDate && formik.errors.startDate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.startDate} </FormHelperText>) : <></>}
                                </Grid>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": edit === false ? "#FAFAFA" : "", "-webkit-text-fill-color": edit === false ? "#000 !important" : "" }, "fieldset": { "border-color": edit === false ? "#FFFFFF !important" : "" } }} classes={{ root: classes.dateTimePicker }} >
                                    <Typography fontWeight="500" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.label.EndDate')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                                        <DesktopDatePicker
                                            slots={{
                                                OpenPickerIcon: serial !== undefined ? adjust === true ? Calendar : null : Calendar
                                            }}
                                            format="dd/MM/yyyy"
                                            value={formik.values.endDate}
                                            onChange={(newValue) => {
                                                // onCheckEndDate(newValue)
                                                selectDate("endDate", newValue);
                                            }}
                                            minDate={formik.values.startDate !== undefined && formik.values.startDate !== null && formik.values.startDate !== "" ? minDate : null}
                                            // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                            inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                            renderInput={(params) => <TextField {...params}
                                                fullWidth
                                                sx={{
                                                    ".MuiOutlinedInput-root": { color: "#404349", },
                                                    ".MuiOutlinedInput-notchedOutline": formik.touched.startDate && formik.errors.startDate ? { borderColor: "#d32f2f !important" } : "",
                                                }}
                                            // classes={{ root: serial !== undefined ? adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                            }
                                        />
                                    </LocalizationProvider>
                                    {formik.touched.endDate && formik.errors.endDate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.endDate}</FormHelperText>) : <></>}
                                </Grid>
                            </Grid>
                            <Grid container display="flex" flexDirection="row-reverse" columnSpacing={4}>
                                <Grid item md xs={6} sx={{ ".MuiCheckbox-root": { p: "0" } }}>
                                    <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" >{t('admin.label.currentCycle')}</Typography>
                                    <Checkbox onChange={handleCheckMakeDefault} checked={formik.values.makeDefault} sx={{ mt: "10px" }}
                                    // disabled={serial !== undefined ? adjust === true ? false : true : false} 
                                    />
                                </Grid>
                                <Grid item md xs={6}>
                                    <Typography fontWeight="500" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.inputForm.cycleType')} <Box fontStyle="italic" sx={{ fontWeight: 500, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    {!serial || serial === undefined || serial === "" ?
                                        <>
                                            <FormControl fullWidth sx={{ mt: "15px" }}>
                                                <Select
                                                    className="custom-placeholder"
                                                    labelId="cycle-type"
                                                    id="cycle-type"
                                                    input={<OutlinedInput size="small" sx={{ border: Boolean(formik.touched.type && formik.errors.type) ? "1px solid red" : "none" }} />}
                                                    value={formik.values.type}
                                                    renderValue={
                                                        formik.values.type !== "" ? undefined : () => <Typography fontSize="16px" fontWeight="300" color="#AAAAAA">{t("adminWorkflow.label.selectTheType")}</Typography>
                                                    }
                                                >
                                                    {typeDropdown.map((option, idx) => {
                                                        return <MenuItem key={idx} value={option.value} onClick={() => handleChangeType(option.value)}><Typography fontWeight="400" fontSize='16px' color='#404349'>{option.text}</Typography></MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {Boolean(formik.touched.type && formik.errors.type) && <FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.type} </FormHelperText>}
                                        </>
                                        :
                                        <Box
                                            sx={{
                                                mt: "15px",
                                                ".MuiInputBase-input": {
                                                    backgroundColor: "#FAFAFA",
                                                    "-webkit-text-fill-color": "#000 !important",
                                                    borderRadius: "4px",
                                                    textTransform: "capitalize"
                                                },
                                                fieldset: { borderColor: "#FFFFFF !important" },
                                            }}
                                        >
                                            <TextField
                                                id="outlined-basic"
                                                value={defaultCycleType.find(item => formik.values.type === item.value)?.text ?? "-"}
                                                variant="outlined"
                                                disabled
                                                fullWidth
                                                size="small"
                                            />
                                        </Box>
                                    }
                                </Grid>
                                {serial !== undefined ?
                                    // adjust === true ?
                                    <Grid container mt={3} mb={3} pr={4} >
                                        <Grid item xs display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button disabled={edit === false ? true : false} onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                    {serial !== undefined ? t(`label.save`) : t(`label.create`)}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    // : null
                                    :
                                    <Grid container mt={3} mb={3} pr={4} >
                                        <Grid item xs display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button disabled={edit === false ? true : false} onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                    {serial !== undefined ? t(`label.save`) : t(`label.create`)}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={serial !== undefined ? t(`admin.label.cycleEditSuccessfully`) : t(`admin.label.cycleCreatedSuccessfully`)}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={errorText + t(`dialog.label.tryAgain`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box>
        </>
    )
};
export default CycleCreate;
